var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-signin-wrapper"},[_c('div',{ref:"googleSignInButton"})])
}
var staticRenderFns = []

export { render, staticRenderFns }